import styled from 'styled-components';
import glow from '../../assets/images/car_glow.png';

const StyledDecor = styled.div`
	position: absolute;
	inset: 0;
	z-index: 0;
	overflow: hidden;
	border-radius: 10px;
	pointer-events: none;
	user-select: none;
`;

const StyledCenter = styled.div`
	position: absolute;
	top: 0;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 500px;
	height: 500px;
	display: flex;
	align-items: center;
	justify-content: center;
`;

const StyledGlow = styled.img`
	position: absolute;
	width: 500px;
	height: 500px;
	max-width: none;
	opacity: 0.15;
`;

const StyledRings = styled.svg`
	position: absolute;
	width: 500px;
	height: 500px;
`;

const StyledShadowTop = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	height: 80px;
	background: linear-gradient(to bottom, #111314 0%, rgba(17, 19, 20, 0) 100%);
`;

const StyledShadowBottom = styled.div`
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	height: 80px;
	background: linear-gradient(to top, #111314 0%, rgba(17, 19, 20, 0) 100%);
`;

const StyledPriceBar = styled.div`
	position: absolute;
	left: 5px;
	right: 5px;
	bottom: 5px;
	height: 48px;
	border-radius: 5px;
	background-color: rgba(0, 0, 0, 0.5);
`;

export {
	StyledCenter,
	StyledDecor,
	StyledGlow,
	StyledPriceBar,
	StyledRings,
	StyledShadowBottom,
	StyledShadowTop,
};

export { glow };
